"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
// ⚠ DO NOT change!!! Long imports are intentional here
var getSettingsValues_1 = require("@wix/tpa-settings/dist/src/contexts/SettingsContext/getSettingsValues");
var loggers_1 = require("@wix/social-groups-common/dist/src/loggers");
var BaseWidgetController_1 = require("@wix/social-groups-common/dist/src/controllers/BaseWidgetController");
var wix_experiments_1 = require("@wix/wix-experiments");
var constants_1 = require("../../config/constants");
var controllers_1 = require("@wix/social-groups-common/dist/src/controllers");
var settings_1 = require("../../settings");
var Controller = /** @class */ (function (_super) {
    tslib_1.__extends(Controller, _super);
    function Controller(controllerConfig, experiments) {
        if (experiments === void 0) { experiments = {}; }
        var _this = _super.call(this, controllerConfig) || this;
        _this.experiments = new wix_experiments_1.default({ experiments: experiments });
        var appParams = controllerConfig.appParams, wixCodeApi = controllerConfig.wixCodeApi, config = controllerConfig.config;
        _this.wixCodeApi = wixCodeApi;
        _this.appParams = appParams;
        _this.config = config;
        _this.controllers = [
            new controllers_1.TranslationsController(controllerConfig, _this.getTranslationsUrl()),
            new controllers_1.BiLoggerController(controllerConfig),
        ];
        _this.setLogger(controllerConfig);
        _this.onUserLogin(function (_a) {
            var instance = _a.instance;
            return tslib_1.__awaiter(_this, void 0, void 0, function () {
                return tslib_1.__generator(this, function (_b) {
                    this.setState({
                        currentUser: this.getCurrentUser(),
                    });
                    return [2 /*return*/];
                });
            });
        });
        return _this;
    }
    Controller.prototype.bootstrapSettings = function (config) {
        var text = getSettingsValues_1.getSettingsValues(config.publicData.COMPONENT || {}, settings_1.textSettings);
        var display = getSettingsValues_1.getSettingsValues(config.publicData.COMPONENT || {}, settings_1.displaySettings);
        var layout = getSettingsValues_1.getSettingsValues(config.publicData.COMPONENT || {}, settings_1.layoutSettings);
        var design = getSettingsValues_1.getSettingsValues(config.publicData.COMPONENT || {}, settings_1.designSettings);
        return {
            text: text,
            design: design,
            display: display,
            layout: layout,
        };
    };
    Controller.prototype.updateConfig = function ($w, updatedConfig) {
        this.config = updatedConfig;
        this.setState({
            styleParams: updatedConfig.style.styleParams,
            appSettings: this.bootstrapSettings(updatedConfig),
        });
        this.controllers.map(function (ctrl) { return ctrl.updateConfig($w, updatedConfig); });
    };
    Controller.prototype.pageReady = function ($w, wixAPI) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: 
                    // Props for SSR
                    return [4 /*yield*/, this.setInitialAppState()];
                    case 1:
                        // Props for SSR
                        _a.sent();
                        this.controllers.map(function (ctrl) { return ctrl.pageReady($w, wixAPI); });
                        return [2 /*return*/];
                }
            });
        });
    };
    Controller.prototype.setInitialAppState = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var initialProps;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getInitialProps()];
                    case 1:
                        initialProps = _a.sent();
                        this.setState(initialProps);
                        return [2 /*return*/];
                }
            });
        });
    };
    Controller.prototype.getInitialProps = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var initialProps, controllersProps, flattenProps, e_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        initialProps = {
                            experiments: this.experiments.all(),
                            cssBaseUrl: this.appParams.baseUrls.staticsBaseUrl,
                            currentUser: this.getCurrentUser(),
                            locale: this.getLocale(),
                            styleParams: this.config.style.styleParams,
                            appSettings: this.bootstrapSettings(this.config),
                            language: this.getSiteLanguage(),
                        };
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, Promise.all(this.controllers.map(function (ctrl) { return ctrl.getInitialProps(); }))];
                    case 2:
                        controllersProps = _a.sent();
                        flattenProps = controllersProps.reduce(function (acc, props) { return (tslib_1.__assign({}, acc, props)); }, {});
                        Object.assign(initialProps, flattenProps);
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _a.sent();
                        console.error('Get Initial Controllers Props: FAIL');
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/, initialProps];
                }
            });
        });
    };
    Object.defineProperty(Controller.prototype, "exports", {
        get: function () {
            return {};
        },
        enumerable: true,
        configurable: true
    });
    Controller.prototype.setLogger = function (controllerConfig) {
        loggers_1.ConsoleLogger.mode = this.getLogLevel(controllerConfig);
    };
    Controller.prototype.getLogLevel = function (controllerConfig) {
        var logLevel = loggers_1.LogLevel.NONE;
        try {
            if (controllerConfig.wixCodeApi.location.query.debug === 'true') {
                logLevel = loggers_1.LogLevel.LOG;
            }
            if (controllerConfig.wixCodeApi.location.query.trace === 'true') {
                logLevel = loggers_1.LogLevel.TRACE;
            }
        }
        catch (e) { }
        return logLevel;
    };
    Controller.prototype.getTranslationsUrl = function () {
        var baseUrl = this.getBaseUrls().staticsBaseUrl;
        var language = this.getSiteLanguage();
        return baseUrl + "assets/locales/" + constants_1.GROUP_LIST + "_" + language + ".json";
    };
    return Controller;
}(BaseWidgetController_1.BaseWidgetController));
exports.Controller = Controller;
//# sourceMappingURL=Controller.js.map